import React from 'react';
import styled from 'styled-components';

import { Button } from '../../../UI/Button';
import infoSrc from '../../assets/info.svg';
import LinkToSrc from '../../assets/link.svg';

const ImageLineWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:after {
    content: '';

    width: 70%;
    height: 1px;

    background-color: ${props => props.theme.bg4};
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;

  position: relative;

  border-radius: 4px;
  overflow: hidden;
`;

const Title = styled.div`
  padding: 27px 0 5px;

  font-family: Bebas Neue, sans-serif;
  font-size: 26px;
  font-weight: bold;
  letter-spacing: 2.08px;
  color: #0a080d;
`;

const LinkTo = styled.a`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 6px;

  font-size: 12px;
  text-decoration: none;
  color: ${props => props.theme.text1};
`;

const EstimatedWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 36px;
  gap: 8px;

  padding: 40px 0;

  border-bottom: 1px solid #e6e6f3;
`;

const AprTitle = styled.div`
  padding-bottom: 8px;

  font-size: 12px;
  color: ${props => props.theme.text1};
`;

const AprPercent = styled.div`
  position: relative;

  font-family: Bebas Neue, sans-serif;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.96px;
  color: #0089e3;

  sup {
    padding-left: 3px;

    font-size: 12px;
  }
`;

const InfoButton = styled(Button)`
  align-self: center;

  width: 36px;
  height: 36px;
`;

const InsightsTitle = styled.div`
  padding: 32px 0;

  font-size: 16px;
  font-weight: 500;
  color: #0a080d;
`;

const InsightsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const InsightRow = styled.div`
  display: flex;
  justify-content: space-between;

  font-size: 14px;

  span {
    color: ${props => props.theme.text1};
  }

  strong {
    color: ${props => props.theme.text0};
  }
`;

export default function ValidatorSidebar() {
  return (
    <div>
      <ImageLineWrapper>
        <ImageWrapper>
          <img src="https://picsum.photos/80" alt="" />
        </ImageWrapper>
      </ImageLineWrapper>
      <Title>Coinbase Custody</Title>
      <LinkTo href="https://www.coinbase.com/custody" target="_blank" rel="noopener noreferrer">
        custody.coinbase.com
        <img src={LinkToSrc} alt="" />
      </LinkTo>
      <EstimatedWrapper>
        <div>
          <AprTitle>Estimated APR</AprTitle>
          <AprPercent>
            8.93<sup>%</sup>
          </AprPercent>
        </div>
        <InfoButton>
          <img src={infoSrc} alt="" />
        </InfoButton>
      </EstimatedWrapper>
      <InsightsTitle>Insights</InsightsTitle>
      <InsightsWrapper>
        <InsightRow>
          <span>Total Bonded</span>
          <strong>10,682,107 NOM</strong>
        </InsightRow>
        <InsightRow>
          <span>Self Bonded Rate</span>
          <strong>0.92%</strong>
        </InsightRow>
        <InsightRow>
          <span>Commission</span>
          <strong>8.90%</strong>
        </InsightRow>
        <InsightRow>
          <span>Voting Power</span>
          <strong>3.2%</strong>
        </InsightRow>
      </InsightsWrapper>
    </div>
  );
}
